import React from "react";
import styles from "./Features.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const FEATURES = [
	{
		title: "Wireless Printer Connection",
		description:
			"Quickly connect your phone to nearby Wi-Fi printers. The app supports most popular printer brands and models.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M6 9V3h12v6" />
				<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
				<path d="M6 14h12v7H6z" />
			</svg>
		),
	},
	{
		title: "Print Documents & Photos",
		description:
			"Print PDFs, Word documents, Excel files, photos, and web pages directly from your phone in just a few taps.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
				<path d="M14 2v6h6" />
				<path d="M8 13h8M8 17h6" />
			</svg>
		),
	},
	{
		title: "Smart Document Scanner",
		description:
			"Scan paper documents, enhance image quality, and save them as clear PDF files for printing or sharing.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<rect x="3" y="4" width="18" height="14" rx="2" />
				<path d="M8 22h8M12 18v4" />
				<circle cx="12" cy="11" r="3" />
			</svg>
		),
	},
	{
		title: "Easy & Powerful Editing",
		description:
			"Preview and prepare files before printing. Crop, rotate, sign, add text, draw, rearrange pages, and adjust print settings with ease.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M12 20h9" />
				<path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
			</svg>
		),
	},
	{
		title: "Google Drive Integration",
		description:
			"Browse and print documents stored in your Google Drive account directly from the app.",
		icon: (
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
				<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
			</svg>
		),
	},
];

function Features() {
	return (
		<section className={cx("features")} id="features">
			<div className={cx("grid")}>
				{FEATURES.map((feature) => (
					<article className={cx("card")} key={feature.title}>
						<div className={cx("icon")} aria-hidden="true">
							{feature.icon}
						</div>
						<h3>{feature.title}</h3>
						<p>{feature.description}</p>
					</article>
				))}
			</div>
		</section>
	);
}

export default Features;
